import { IsString, IsOptional, IsBoolean, IsDateString, ValidateIf, IsNumber, ValidateNested } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { Archived } from '@/modules/category/schemas/category.schema';
import { MultilingualTextDto } from '@/common/dto/multilingual-text.dto';

export class CreateHeroDto {
  @ApiProperty({ type: MultilingualTextDto, description: 'Hero title in multiple languages' })
  @ValidateNested()
  @Type(() => MultilingualTextDto)
  title: MultilingualTextDto;

  @ApiPropertyOptional({ type: MultilingualTextDto, description: 'Hero subtitle in multiple languages' })
  @IsOptional()
  @ValidateNested()
  @Type(() => MultilingualTextDto)
  subTitle?: MultilingualTextDto;

  @ApiPropertyOptional({ type: MultilingualTextDto, description: 'Button name in multiple languages' })
  @IsOptional()
  @ValidateNested()
  @Type(() => MultilingualTextDto)
  buttonName?: MultilingualTextDto;

  @ApiPropertyOptional({ description: 'Button link' })
  @IsOptional()
  @IsString()
  buttonLink?: string;

  @ApiPropertyOptional({ description: 'Hero image' })
  @IsOptional()
  image?: Archived;

  @ApiPropertyOptional({ description: 'Hero video' })
  @IsOptional()
  video?: Archived;

  @ApiPropertyOptional({ description: 'Whether video should autoplay', default: true })
  @IsOptional()
  @IsBoolean()
  videoAutoplay?: boolean;

  @ApiPropertyOptional({ description: 'Start date for scheduled hero' })
  @ValidateIf((o) => !o.isAlways)
  @IsDateString()
  startDate?: Date;

  @ApiPropertyOptional({ description: 'End date for scheduled hero' })
  @ValidateIf((o) => !o.isAlways)
  @IsDateString()
  endDate?: Date;

  @ApiProperty({ description: 'Whether hero is always active', default: false })
  @IsBoolean()
  isAlways: boolean;

  @ApiPropertyOptional({ description: 'Whether hero is active', default: true })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean;

  @ApiPropertyOptional({ description: 'Order of hero', default: 0 })
  @IsOptional()
  @IsNumber()
  order?: number;
} 